export const spacing = {
    s0: "0",
    s1: "0.25rem",
    s2: "0.5rem",
    s3: "1rem",
    s4: "2rem",
    s5: "4rem",
    s6: "8rem",
    s7: "16rem",
    s8: "32rem",
}

export const typeScale = {
    t1: "0.354rem",
    t2: "0.5rem",
    t3: "0.707rem",
    t4: "1rem",
    t5: "1.414rem",
    t6: "1.999rem",
    t7: "2.827rem",
    t8: "3.998rem",
}

export const mq = {
    xsmall: "35em",
    small: "40em",
    medium: "50em",
    large: "65em",
    xlarge: "75em",
}